{
  "optionalTranslationKeyNotSet": "Optional translation key not set",
  "aboutme": {
    "hello": "Hello",
    "iam": "I am",
    "title": "Developer, DJ & Producer from Berlin",
    "description": "{age} years old, based in Berlin, living somewhere between code and beats. By day I study Computer Science at TU Berlin, by night I produce tracks or work on my projects. My internship at KfW showed me I can handle IT operations too – but my heart beats for development. Whether building software or making music: as long as it's creative.",
    "myPlaylist": "My Playlist",
    "myCurrentSong": "My Latest Song"
  },
  "aiLabel": {
    "title": "AI Transparency Notice",
    "description": "Parts of this website were developed with the assistance of Artificial Intelligence (AI). AI tools were utilized for internationalization (translation), design implementation, and linguistic refinement. However, all factual information and core content remain 100% authentic, human-verified, and have not been altered, falsified, or independently generated by AI.",
    "readMore": "Learn more about the EU AI Label",
    "link": "https://digital-strategy.ec.europa.eu/en/policies/eu-icons-labelling-ai-generated-content"
  },
  "commandMenu": {
    "searchPlaceholder": "Type a command or search...",
    "noResults": "No results found.",
    "languages": "Languages",
    "settings": "Settings",
    "misc": "Miscellaneous",
    "cookieSettings": "Cookie Settings",
    "commandPalette": "Command Palette",
    "commandPaletteDescription": "Search for a command to run"
  },
  "common": {
    "loading": "Loading...",
    "error": "Error",
    "success": "Success",
    "cancel": "Cancel",
    "save": "Save",
    "delete": "Delete",
    "edit": "Edit",
    "view": "View",
    "submit": "Submit",
    "close": "Close"
  },
  "contact": {
    "description": "Let's connect! Book a meeting.",
    "bookMeeting": "Book a Meeting",
    "calDescription": "Schedule a call or meeting via Cal.com",
    "mobilephone": "Mobile Phone",
    "address": "Address"
  },
  "cookieConsent": {
    "title": "Cookie Notice",
    "description": "This website uses cookies to ensure you get the best experience. We do not collect any analytics data about you or your device. Only technically necessary cookies are set by default. Third-party content can be blocked at your discretion. Your cookie preferences are stored for 7 days.",
    "technicalCookies": {
      "title": "Technical Cookies",
      "description": "These cookies are required for basic site functionality, such as remembering your preferences and language settings. They cannot be disabled. No personal or analytical data is collected."
    },
    "thirdPartyCookies": {
      "title": "Third-Party Content",
      "description": "Some pages contain embedded content from third-party services like Cal.com or Apple Music. These services may set their own cookies, which are outside of my control. You can block this content at any time via your cookie settings."
    },
    "acceptAll": "Accept All",
    "rejectAll": "Reject All",
    "managePreferences": "Manage Preferences",
    "savePreferences": "Save Preferences",
    "moreInfo": "More Information",
    "cookieSettings": "Cookie Settings",
    "language": "Language",
    "categories": {
      "multimedia": {
        "description": "Required for embedded media like Apple Music and Songlink players."
      },
      "socialMedia": {
        "description": "Required for embedded social media content."
      },
      "contact": {
        "title": "Contact & Booking",
        "description": "Required for the Cal.com booking calendar."
      },
      "tracking": {
        "title": "Analytics & Tracking",
        "description": "Enables the collection of information about website usage to improve your experience."
      }
    },
    "blockedContent": {
      "title": "Content Blocked",
      "description": "This content is blocked because you haven't accepted the required cookies. Enable the corresponding category: ({category}) in your cookie settings to view this content.",
      "button": "Cookie Settings"
    }
  },
  "cv": {
    "recommendation": {
      "printingSettings": {
        "title": "Optimal Print Settings",
        "description": "Scale: 62%, Margins: Default, Background Graphics: On"
      },
      "printingNotice": {
        "title": "Print Recommendation",
        "description": "Use the PDF button in the top right corner for optimal printing."
      }
    },
    "about": {
      "title": "Certified IT Assistant | Software Developer",
      "email": "Email",
      "telnum": "Phone",
      "address": {
        "germany": "Germany"
      },
      "birthday": "Date of Birth"
    },
    "education": {
      "title": "Education",
      "items": {
        "tuberlin": {
          "name": "Technical University of Berlin",
          "imgAlt": "Technical University of Berlin Logo",
          "description": "Bachelor of Science in Computer Science – Focus areas: Algorithms, Data Structures, Software Engineering",
          "badges": ["Berlin", "Bachelor of Science", "Computer Science"]
        },
        "lookingForApprenticeship": {
          "name": "Gap Year",
          "imgAlt": "Actively Seeking Position",
          "description": "I spent this period actively seeking an apprenticeship as an IT Specialist for Application Development or a dual studies programs in the field of Computer Science while continuing my personal coding projects."
        },
        "oszimt": {
          "name": "Berlin Technical College for IT and Medical Technology",
          "imgAlt": "OSZ IMT Berlin Logo",
          "description": "Dual qualification: Certified IT Assistant with Technical Diploma. Core competencies: Software Development (Java), Network Administration (Cisco), Database Management (MySQL)",
          "badges": [
            "Berlin",
            "Vocational Training",
            "Technical Diploma",
            "Computer Science"
          ]
        },
        "cvl": {
          "name": "Carl-von-Linné-School Berlin",
          "imgAlt": "Carl-von-Linné-School Logo",
          "description": "Secondary School Certificate with qualification for advanced secondary education",
          "badges": ["Berlin", "SSC (HS-E L)"]
        }
      }
    },
    "experience": {
      "title": "Professional Experience",
      "items": {
        "kfw": {
          "name": "KfW Banking Group – IT Department",
          "imgAlt": "KfW Banking Group Logo",
          "description": "• Developed and implemented automation scripts using Ansible to streamline IT operations\n• Created technical documentation in Confluence for knowledge management\n• Collaborated with IT team to improve infrastructure processes",
          "badges": [
            "Berlin",
            "IT Internship",
            "Ansible",
            "Automation",
            "Confluence"
          ]
        },
        "adk": {
          "name": "Academy of Arts Berlin",
          "imgAlt": "Academy of Arts Logo",
          "description": "• Assisted in digital synthesizer software development\n• Gained experience at the intersection of technology and creative arts",
          "badges": [
            "Berlin",
            "Software Development",
            "Music Technology",
            "Student Internship"
          ]
        },
        "tosa": {
          "name": "Tosa Security & Service GmbH & Co KG",
          "imgAlt": "Tosa Security & Service Logo",
          "description": "• Handled administrative tasks and office organization\n• Developed understanding of business operations",
          "badges": ["Trebbin", "Office Administration", "Student Internship"]
        },
        "pfennig": {
          "name": "Pfennigpfeiffer Retail GmbH",
          "imgAlt": "Pfennigpfeiffer Logo",
          "description": "• First work experience in retail: Product merchandising and customer service",
          "badges": ["Berlin", "Retail", "Student Internship"]
        }
      }
    },
    "skills": {
      "title": "Skills & Abilities",
      "badges": {
        "development": "Software Development",
        "configuration": "System Configuration",
        "operatingSystem": "Operating System",
        "frontend": "Frontend Development",
        "automation": "IT Automation",
        "office": "Office Applications",
        "textEditor": "Text Editor",
        "multifunctional": "Multifunctional",
        "retail": "Retail",
        "language": "Language",
        "native": "Native Speaker"
      },
      "categories": {
        "languages": {
          "title": "Languages"
        },
        "programming": {
          "title": "Programming Languages"
        },
        "databases": {
          "title": "Databases"
        },
        "automation": {
          "title": "Automation & DevOps"
        },
        "operatingSystems": {
          "title": "Operating Systems"
        },
        "networking": {
          "title": "Networking"
        },
        "devEnvironments": {
          "title": "Development Environments"
        },
        "office": {
          "title": "Office & Collaboration"
        }
      }
    },
    "durationKeys": {
      "years": "{count} Years",
      "year": "{count} Year",
      "semesters": "{count} Semesters",
      "semester": "{count} Semester",
      "quarters": "{count} Quarters",
      "quarter": "{count} Quarter",
      "months": "{count} Months",
      "month": "{count} Month",
      "weeks": "{count} Weeks",
      "week": "{count} Week",
      "days": "{count} Days",
      "day": "{count} Day"
    }
  },
  "footer": {
    "connect": "Connect",
    "legal": "Legal",
    "rights": "All rights reserved."
  },
  "imprint": {
    "title": "Legal Notice",
    "tmg": {
      "title": "Information according to § 5 TMG (German Telemedia Act)",
      "germany": "Germany"
    },
    "contact": {
      "title": "Contact"
    },
    "rstv": {
      "title": "Responsible for content according to § 55 Abs. 2 RStV (German Interstate Broadcasting Treaty)"
    },
    "cookies": {
      "title": "Cookie Policy",
      "description": "This website uses cookies to ensure the best possible experience. We do not collect any analytics data about you or your device. Below you will find detailed information about the cookies used on this site.",
      "technical": {
        "title": "Technical Cookies",
        "description": "We only use technically necessary cookies that are essential for the website to function properly. These include cookies for storing your language preference and cookie consent status. These cookies cannot be disabled."
      },
      "thirdParty": {
        "title": "Third-Party Content (Blockable)",
        "description": "Some pages contain embedded content from third-party services. These services may set their own cookies, which are outside of my control. You can block this content at any time via your cookie settings."
      },
      "storage": {
        "title": "Consent Storage",
        "description": "Your cookie preferences are stored locally in a cookie for 7 days. After that, you will be asked again. You can change your preferences at any time by clicking the Cookie Settings button below or in the footer."
      }
    }
  },
  "layout": {
    "title": "Fabian Aps Portfolio/Imprint",
    "description": "my own portfolio/imprint website"
  },
  "linkhub": {
    "description": "Code, beats, or random content – find me everywhere.",
    "sections": {
      "socialMedia": {
        "description": "The platforms where I'm active.",
        "instagram": {
          "description": "Stories from daily life, events, and everything else."
        },
        "tiktok": {
          "description": "When I want to show something creative in under a minute."
        },
        "threads": {
          "description": "My thoughts when Instagram isn't enough."
        },
        "bsky": {
          "description": "For everyone looking for a Twitter alternative."
        },
        "twitter": {
          "description": "Tech discussions and the occasional rant."
        },
        "discord": {
          "description": "Reach me directly here – or just hang out."
        },
        "youtube": {
          "description": "Tutorials, music releases, and whatever else comes to mind."
        }
      },
      "websites": {
        "description": "Projects that live on the web.",
        "myWebsite": {
          "title": "This Website",
          "description": "You're already here – but feel free to look around."
        },
        "cbps": {
          "headding": "The Crew Site",
          "description": "My friend group's website – chaotic, but made with love."
        },
        "blogCBPS": {
          "headding": "News & Stories",
          "description": "Updates from the crew's life."
        }
      },
      "other": {
        "title": "More From Me",
        "description": "What doesn't fit in the other categories.",
        "gitlab": {
          "description": "Where my code lives – open source and personal projects. My new Home for code."
        },
        "github": {
          "description": "Where my code lives – open source and personal projects. My old Home for code."
        },
        "playlist": {
          "title": "My Playlist",
          "headding": "What I'm Listening To",
          "description": "From techno to indie – my current soundtrack."
        },
        "song": {
          "title": "My Song",
          "description": "My latest track – give it a listen!"
        }
      }
    }
  },
  "projects": {
    "pinned": "Pinned Projects",
    "title": "Projects",
    "all": "All Projects",
    "projectCount": "{count} Projects",
    "searchPlaceholder": "Search projects…",
    "showingResultsFor": "Showing results for \"{query}\"",
    "noResults": "No projects found.",
    "clearSearch": "Clear search",
    "items": {
      "portfolio": {
        "title": "This Portfolio",
        "description": "The site you're on right now. Next.js, TypeScript, and way too many late nights with CSS.",
        "imgAlt": "Portfolio Screenshot"
      },
      "simplesql": {
        "description": "When you want to run SQL statements without setting up an IDE for half an hour. TUI for quick queries.",
        "imgAlt": "simplesql Terminal Interface"
      },
      "localServices": {
        "title": "My Self-Hosted Stack",
        "description": "SearxNG, Nextcloud, and everything else you need when you don't want to tell Google everything.",
        "imgAlt": "SearxNG Logo"
      },
      "schulRepo": {
        "title": "School Repository",
        "description": "Three years of OSZ IMT in code – from first Java baby steps to real projects.",
        "imgAlt": "OSZ IMT Logo"
      },
      "klassenWebsite": {
        "description": "The official class website. Built with the crew, hosted with pride.",
        "imgAlt": "OSZ IMT Logo"
      },
      "klassenApp": {
        "description": "Schedule changes, grade calculator, class chat – everything we needed in school.",
        "imgAlt": "Class App Icon"
      },
      "simpleSqlRunner": {
        "description": "The GUI version of simplesql. For those who prefer clicking over typing.",
        "imgAlt": "Simple SQL Runner Screenshot"
      },
      "dotfilesMacos": {
        "description": "My complete Mac setup in one repo. Zsh, Neovim, Homebrew – all included.",
        "imgAlt": "Terminal with Dotfiles"
      },
      "nixConfig": {
        "description": "Reproducible system setup. Configure once, deploy anywhere.",
        "imgAlt": "NixOS Logo"
      },
      "dotfilesLinux": {
        "description": "Same philosophy, different OS. Hyprland, Waybar, and the whole Wayland stack.",
        "imgAlt": "Linux Desktop Screenshot"
      },
      "cbpsWebsite": {
        "description": "The digital home of my friend group. Chaotic, colorful, and absolutely us.",
        "imgAlt": "comboom.sucht Logo"
      },
      "cbpsApp": {
        "description": "Plan private events, share memes, collect inside jokes – the crew app.",
        "imgAlt": "comboom.sucht App Icon"
      },
      "uniRepo": {
        "title": "TU Berlin Repository",
        "description": "Algorithms, data structures, and proof that I can actually do math.",
        "imgAlt": "TU Berlin Logo"
      },
      "liveWallpaper": {
        "title": "Interactive Live Wallpaper",
        "description": "Particles in Nord theme, C++23 under the hood, runs native and in browser. My playground for shader experiments.",
        "imgAlt": "Live Wallpaper Preview"
      }
    }
  },
  "recommendation": {
    "projects": {
      "title": "From Idea to Code",
      "description": "See what happens when I can't sleep at night.",
      "action": {
        "label": "Explore Projects"
      }
    },
    "aboutme": {
      "title": "The Person Behind the Code",
      "description": "IT nerd by day, DJ by night – get to know me.",
      "action": {
        "label": "Learn More"
      }
    },
    "cv": {
      "title": "From School to TU Berlin",
      "description": "My journey through the IT world – all the stops.",
      "action": {
        "label": "View Resume"
      }
    },
    "linkhub": {
      "title": "Find Me Everywhere",
      "description": "From Instagram to GitHub – here's where I hang out.",
      "action": {
        "label": "All Profiles"
      }
    },
    "gitlab": {
      "title": "Where the Code Lives",
      "description": "@mcpeaps_HD – Open source with passion. My new Home for code.",
      "action": {
        "label": "On GitLab"
      }
    },
    "github": {
      "title": "Where the Code Lives",
      "description": "@mcpeapsUnterstrichHD – Open source with passion. My old Home for code.",
      "action": {
        "label": "On GitHub"
      }
    },
    "twitter": {
      "title": "My Unfiltered Thoughts",
      "description": "@mcpeaps_HD – Tech talks and random thoughts.",
      "action": {
        "label": "On X"
      }
    },
    "instagram": {
      "title": "Between Code and Beats",
      "description": "@mcpeaps_hd – My daily life in pictures.",
      "action": {
        "label": "On Instagram"
      }
    },
    "tiktok": {
      "title": "When It Has to Be Quick",
      "description": "@mcpeaps_hd – Content in 60 seconds.",
      "action": {
        "label": "On TikTok"
      }
    },
    "threads": {
      "title": "More Than 280 Characters",
      "description": "@mcpeaps_hd – When a tweet isn't enough.",
      "action": {
        "label": "On Threads"
      }
    },
    "bluesky": {
      "title": "The New Social Media",
      "description": "@mcpeapsunterstrichhd.dev – Decentralized and free.",
      "action": {
        "label": "On Bluesky"
      }
    }
  },
  "sidebar": {
    "toggleSidebar": "Toggle Sidebar",
    "noLanguageFound": "No language found.",
    "searchLanguage": "Search language..."
  },
  "sites": {
    "root": "Home",
    "imprint": "Imprint",
    "aboutme": "About Me",
    "projects": "Projects",
    "contact": "Contact Me",
    "cv": "Resume",
    "linkhub": "Link List",
    "notFound": "404 - Page Not Found"
  },
  "reloadPrompt": {
    "message": "A new version is available. Please refresh the page.",
    "refresh": "Refresh"
  }
}
